import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { Image } from 'wix-rich-content-ui-components';

import type { PollsMember } from '../../types';
import FallbackAvatar from './FallbackAvatar';

export default function (props: {
  className: string;
  member: PollsMember;
  size: {
    width: number;
    height: number;
  };
  src?: string;
}) {
  const { className, src, member, size } = props;
  const { t } = useContext(RicosContext);

  return src ? (
    <Image
      uri={src}
      displayMode="fill"
      alt={member.name?.nick || t('Polls_Plugin_User_Avatar_Alt')}
      height={size.height}
      width={size.width}
      containerProps={{
        className,
        style: size,
      }}
    />
  ) : (
    <FallbackAvatar className={className} />
  );
}
